import { createReducer, on } from '@ngrx/store';
import { UserState } from './user.model';
import { UserActions } from './user.actions';

const initialState: UserState = {
  user: null,
  returnUrl: '',
  error: null,
};

export const reducer = createReducer<UserState>(
  initialState,
  on(UserActions.setUser, (state, { user }) => ({
    ...state,
    user,
    error: null,
  })),
  on(UserActions.setReturnUrl, (state, { returnUrl }) => ({
    ...state,
    returnUrl,
  })),
  on(UserActions.logOut, state => ({ ...state, user: null, error: null })),
  on(UserActions.authError, (state, { error }) => ({
    ...state,
    user: null,
    returnUrl: '',
    error,
  })),
);
